import { gql } from '@apollo/client';

export const GET_ACTIVITY = gql`
  query activity($id: String!) {
    activity(id: $id) {
      _id
      type
      challengeable
      numberOfDays
      title
      shortDescription
      estimatedTime
      image
      designSystemColor
      migratedFromExercice
      session {
        _id
      }
    }
  }`;

export const GET_MY_ACTIVITY = gql`
  query startedUserActivity {
    startedUserActivity {
      _id
      status
      isChallenge
      reminderEnabled
      reminderTime
      dateCreated
      dateUpdated
      endDate
      days {
        done
        maxDate
        entry
        dateOfCompletion
      }
      activity {
        _id
        type
        challengeable
        numberOfDays
        title
        shortDescription
        estimatedTime
        image
        designSystemColor
        migratedFromExercice
        session {
          _id
        }
      }
    }
  }`;

/** the user's whole history on an activity: challenge days and free entries, newest first */
export const GET_MY_ACTIVITY_ENTRIES = gql`
  query myActivityEntries($activityId: String!) {
    myActivityEntries(activityId: $activityId) {
      userActivity
      isChallenge
      day
      entryIndex
      date
      entry
    }
  }`;
